export const privacyPolicyInitialState = {
  content: '',
};
